import { Flex } from 'antd';
import { ReactNode } from 'react';

interface PageLayoutProps {
  children: ReactNode;
  bottomSheet?: ReactNode;
  className?: string;
}

/**
 * PageLayout component that provides consistent layout structure for pages with Bottom Sheet
 *
 * This component ensures:
 * - Uses natural document scrolling (no internal scroll containers)
 * - Bottom Sheet uses sticky positioning to stay at viewport bottom
 * - Content area grows via flex-1 so sticky anchors at bottom even with short content
 * - No hardcoded heights - adapts automatically to all layout changes
 * - No horizontal overflow
 */
const PageLayout = ({ children, bottomSheet, className = '' }: PageLayoutProps) => {
  return (
    <div className={`relative min-w-0 flex-1 flex flex-col ${className}`}>
      <div className='min-w-0 flex-1'>{children}</div>

      {bottomSheet && (
        <div className='sticky bottom-4 left-0 right-0 z-30 pointer-events-none px-4'>
          <div className='pointer-events-auto'>
            {bottomSheet}
          </div>
        </div>
      )}
    </div>
  );
};

export default PageLayout;
